import { LuEllipsis } from "react-icons/lu";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

interface WeeklyPostChartProps {
  weeklyPosts: {
    name: string;
    job: number;
    project: number;
  }[];
}

const LuEllipsisIcon = LuEllipsis as React.ElementType;

export const WeeklyPostChart: React.FC<WeeklyPostChartProps> = ({
  weeklyPosts,
}) => {
  return (
    <div className="rounded-2xl w-full h-full p-4 border">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">Posts</h1>
        <LuEllipsisIcon />
      </div>
      {/* CHART */}
      <div className="h-full">
        <ResponsiveContainer width="100%" height="90%">
          <BarChart width={500} height={300} data={weeklyPosts} barSize={20}>
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#ddd"
            />
            <XAxis
              dataKey="name"
              axisLine={false}
              tick={{ fill: "#d1d5bd" }}
              tickLine={false}
            />
            <YAxis
              axisLine={false}
              tick={{ fill: "#d1d5bd" }}
              tickLine={false}
            />
            <Tooltip
              contentStyle={{ borderRadius: "10px", borderColor: "lightgray" }}
            />
            <Legend
              align="left"
              verticalAlign="top"
              wrapperStyle={{
                paddingTop: "20px",
                paddingBottom: "40px",
              }}
            />
            <Bar
              dataKey="job"
              fill="#c7d2fe"
              legendType="circle"
              radius={[10, 10, 0, 0]}
            />
            <Bar
              dataKey="project"
              fill="#bae6fd"
              legendType="circle"
              radius={[10, 10, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
